const benefits = [
  { icon: 'ri-organization-chart', value: '100%', title: 'Mais Controle', desc: 'Organização total dos números da empresa com relatórios claros e atualizados.' },
  { icon: 'ri-shield-check-line', value: 'Zero', title: 'Riscos Fiscais', desc: 'Conformidade total que elimina riscos de autuações, multas e problemas com o Fisco.' },
  { icon: 'ri-line-chart-line', value: '2x', title: 'Decisões Mais Assertivas', desc: 'Dados confiáveis que transformam a qualidade das decisões estratégicas do negócio.' },
  { icon: 'ri-building-line', value: 'Sólido', title: 'Crescimento Estruturado', desc: 'Base contábil e fiscal robusta que suporta o crescimento da empresa com segurança.' },
  { icon: 'ri-time-line', value: 'Ágil', title: 'Economia de Tempo', desc: 'Você foca no negócio enquanto cuidamos de toda a burocracia fiscal e contábil.' },
];

const forWhom = [
  'Empresas que faturam e querem aumentar o lucro',
  'Negócios que buscam segurança e organização',
  'Empresas que desejam reduzir riscos fiscais',
  'Gestores que querem sair do básico e ter estratégia',
];

export default function BeneficiosSection() {
  return (
    <section id="beneficios" className="py-24 bg-[#f8f6f2]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">Benefícios</span>
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-[#0f2651] mt-3 mb-5">
            O que sua empresa<span className="text-[#c9a84c]"> ganha</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Resultados tangíveis e mensuráveis que impactam diretamente o desempenho financeiro da sua empresa.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {benefits.map((b) => (
            <div key={b.title} className="bg-white border border-gray-100 rounded-lg p-7 hover:border-[#c9a84c]/20 transition-colors duration-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-11 h-11 flex items-center justify-center bg-[#0f2651] rounded-lg text-[#c9a84c] flex-shrink-0">
                  <i className={`${b.icon} text-xl`} />
                </div>
                <div className="text-2xl font-bold text-[#0f2651]">{b.value}</div>
              </div>
              <h3 className="text-lg font-bold text-[#0f2651] mb-2">{b.title}</h3>
              <p className="text-gray-500 text-base leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white border border-gray-100 rounded-xl overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-10">
              <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">Para Quem É</span>
              <h3 className="font-serif text-2xl font-bold text-[#0f2651] mt-3 mb-6">
                A RCP foi feita para empresas que querem mais
              </h3>
              <ul className="space-y-4">
                {forWhom.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#c9a84c] flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-lg" />
                    </div>
                    <span className="text-gray-600 text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative min-h-[360px] md:min-h-full">
              <img
                alt="Profissional contábil analisando relatórios financeiros e gráficos em escritório moderno"
                className="w-full h-full object-cover object-center absolute inset-0"
                src="https://public.readdy.ai/ai/img_res/edited_be59e7b800ff14dd053e0351719dd11c_532a827a.jpg"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
